import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MyNavbar from './components/MyNavbar';
import Home from './components/Home';
import SplashScreen from './components/SplashScreen';
import axios from 'axios';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import Register from './components/Register';
import Profile from './components/Profile';
import Booking from './components/Booking';
import BookingHistory from './components/BookingHistory';
import Footer from './components/Footer';
import InstallPWA from './components/InstallPWA';
import Qrcode from './components/Qrcode';
import ScrollToTop from './components/ScrollToTop';

// Admin Imports
import AdminLogin from './Admin/AdminLogin';
import AdminLayout from './Admin/AdminLayout';
import AdminDashboard from './Admin/AdminDashboard';
import AddServices from './Admin/AddServices';
import AdminBookings from './Admin/AdminBookings';
import AdminProfile from './Admin/AdminProfile';
import AdminUsers from './Admin/AdminUsers';

import './App.css';

// Configure axios interceptors for JWT
axios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const userToken = localStorage.getItem('userToken');
    const token = adminToken || userToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const hasSeenSplash = sessionStorage.getItem('hasSeenSplash');

    if (hasSeenSplash) {
      setLoading(false);
      setFadeOut(true);
      return;
    }

    const timer1 = setTimeout(() => setFadeOut(true), 2000);
    const timer2 = setTimeout(() => {
      setLoading(false);
      sessionStorage.setItem('hasSeenSplash', 'true');
    }, 2500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  // We can't use useLocation here because it needs to be inside Router
  // We'll use a hacky way or just restructure a bit more
  return (
    <Router>
      <ScrollToTop />
      <AppContent fadeOut={fadeOut} loading={loading} />
    </Router>
  );
}

function AppContent({ fadeOut, loading }) {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin') && location.pathname !== '/admin_login';
  const isLogin = location.pathname === '/admin_login';
  const isAdmin = isDashboard || isLogin;

  return (
    <>
      {loading && <SplashScreen fadeOut={fadeOut} />}
      {!isAdmin && <InstallPWA />}
      {!isAdmin && <MyNavbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/booking-history" element={<BookingHistory />} />
        <Route path="/qrcode" element={<Qrcode />} />

        {/* Admin Routes */}
        <Route path="/admin_login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="add-services" element={<AddServices />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="profile" element={<AdminProfile />} />
        </Route>
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

export default App;

